/* eslint no-param-reassign: ["error", { "props": false }]*/
// calculate and set new position of a table row
export default function(tr, newPosition) {
  // calculate movement direction
  let movement = 0;

  if (newPosition < tr.startingPosition) {
    movement = -1;
  }

  if (newPosition > tr.startingPosition) {
    movement = 1;
  }

  // calculate amount to move
  const amount = newPosition - tr.currentPosition;

  // set new position if changed
  // set data-animating attribute
  if (tr.currentPosition !== newPosition) {
    tr.currentPosition = newPosition;
    tr.setAttribute('data-animating', true);
  }

  // set movement attribute
  tr.setAttribute('data-movement', movement);

  // animate row
  tr.style.cssText = `transform: translateY(${amount * 100}%)`;
}
